import { authenticatedGet, authenticatedPost } from "../base/util/api";
import { logError, showError, showSuccess } from "../base/util/alerts";

export const SCALES_FETCH = "scales/fetch";
export const SCALES_SET = "scales/set";
export const SCALE_SELECTED_SET = "scales/selected/set";
export const SCALE_SELECTED_CLEAR = "scales/selected/clear";

export const selectScale = (id) => ({
  type: SCALE_SELECTED_SET,
  id,
});

const fetching = (state = true) => ({
  type: SCALES_FETCH,
  fetching: state,
});

export const loadScales = () => (dispatch) => {
  dispatch(fetching());
  return authenticatedGet("scale")
    .then((res) => {
      dispatch({
        type: SCALES_SET,
        scales: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const loadAllScales = () => (dispatch) => {
  dispatch(fetching());
  return authenticatedGet("scale/all")
    .then((res) => {
      dispatch({
        type: SCALES_SET,
        scales: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const loadScalesByUser = (userId) => (dispatch) => {
  dispatch(fetching());
  return authenticatedGet(`user/${userId}/scales`)
    .then((res) => {
      dispatch({
        type: SCALES_SET,
        scales: res,
      });
    })
    .catch((msg) => logError(msg.message));
};

export const clearSelectedScale = () => ({
  type: SCALE_SELECTED_CLEAR,
});

const splitChannel = (channel) => (channel ? channel.split(":") : [null, null]);

export const createScale = (data) => {
  return (dispatch) => {
    const [controllerId, channelId] = splitChannel(data.channel);
    dispatch(fetching());
    return authenticatedPost("scale", {
      ...data,
      controllerId,
      channelId,
    })
      .then((msg) => {
        showSuccess(msg.message);
        dispatch(loadScales());
      })
      .catch((e) => {
        showError(e.message);
        dispatch(fetching(false));
        throw e;
      });
  };
};

export const updateScale = (data) => {
  return (dispatch) => {
    dispatch(fetching());
    const id = data.idscale;
    const [controllerId, channelId] = splitChannel(data.channel);
    return authenticatedPost("scale/" + id, {
      ...data,
      controllerId,
      channelId,
    })
      .then((msg) => {
        showSuccess(msg.message);
        dispatch(loadScales());
      })
      .catch((e) => {
        showError(e.message);
        dispatch(fetching(false));
        throw e;
      });
  };
};
